var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner",style:({'background-image':'url('+_vm.bgImg+')',backgroundPosition:'center','color':_vm.bgColor})},[_c('div',{staticClass:"banner-wrap"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }